module.exports = __webpack_public_path__ + "static/icon9-3edba3b330de51336eef54a527c2922e.svg";